import { ClientState } from "shared/datamodel/schemas";
import style from "./following-collaborator-container.module.css";

export default function FollowingCollaboratorContainer({
  collaborator,
  isCIM = false,
}: {
  collaborator: ClientState | null;
  isCIM?: boolean;
}) {
  if (!collaborator) {
    return null;
  }

  return (
    <div
      className={style.container}
      style={{ border: `4px solid ${collaborator.userInfo.color}`, top: isCIM ? "0" : undefined }}
    >
      <div
        className={style.collaboratorName}
        style={{ background: collaborator.userInfo.color, color: collaborator.userInfo.textColor }}
      >
        Following {collaborator.userInfo.name}
      </div>
    </div>
  );
}
